import React, { useState } from "react";
import { SimpleDialog } from "../../components/dialogs/SimpleDialog";
import { MenuItem, Select } from "@mui/material";
import {
  PropertyPhotoCategory,
  PropertyPhotoCategoryTranslations,
} from "common/types/common.types";

interface PhotoCategoryEditDialogProps {
  open: boolean;
  onClose: () => void;
  isLoading: boolean;
  currentCategory: PropertyPhotoCategory;
  onSubmit: (category: PropertyPhotoCategory) => void;
}

export const PhotoCategoryEditDialog: React.FC<
  PhotoCategoryEditDialogProps
> = ({ open, onClose, isLoading, currentCategory, onSubmit }) => {
  const [category, setCategory] = useState(currentCategory);

  return (
    <SimpleDialog
      title="Keisti kategoriją"
      open={open}
      isLoading={isLoading}
      onClose={onClose}
      buttonDisabled={category === currentCategory}
      onSubmit={() => onSubmit(category)}
      width="400px"
    >
      <Select
        value={category}
        onChange={(e) => setCategory(e.target.value as PropertyPhotoCategory)}
        sx={{ mt: 2 }}
      >
        {Object.values(PropertyPhotoCategory).map((cat) => (
          <MenuItem key={cat} value={cat}>
            {PropertyPhotoCategoryTranslations[cat] ?? "Kita"}
          </MenuItem>
        ))}
      </Select>
    </SimpleDialog>
  );
};
